import {Component, OnInit} from '@angular/core';
import {LocalizeService} from '../../../../../services/localize.service';
import {SharedService} from '../../../../../services/shared.service';
import {CompanyDetailsService} from '../../../../../services/company-details.service';

@Component({
  selector: 'app-contacts-russia-details',
  templateUrl: './contacts-russia-details.component.html',
  styleUrls: ['../../../general/general.component.scss']
})
export class ContactsRussiaDetailsComponent implements OnInit {

  constructor(public localize: LocalizeService,
              public sharedService: SharedService,
              public companyService: CompanyDetailsService) {
    this.companyService.getCompanyContacts('RUSSIA');
  }

  ngOnInit(): void {
  }

}
